import { Link } from "react-router-dom";
import { FooterRoutes } from "../constant";
import { nanoid } from "nanoid";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/app/hooks";
import { setIsSticky } from "../redux/features/userAuth/userAuth";

type Props = {};

const FooterComponent = (props: Props) => {
  const FooterRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const handleScroll = () => {
      if (FooterRef?.current?.offsetTop) {
        if (window.pageYOffset >= FooterRef?.current?.offsetTop - FooterRef?.current?.offsetHeight) {
          dispatch(setIsSticky(true));
        } else {
          dispatch(setIsSticky(false));
        }
        if (FooterRef?.current?.offsetTop - FooterRef?.current?.offsetHeight <= 0) {
          dispatch(setIsSticky(false));
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [FooterRef]);

  return (
    <div className="justify-center items-center py-3 flex flex-col text-white background-primary">
      <div className="container py-[12px] text-sm flex justify-center">
        {/* <p>Copyright @ 2026 JewelMaker. All right reserved.</p>
        <div className="flex gap-2 underline justify-center">
          <Link to={"/privacyPolicy"}>Privacy Policy </Link>
          <span className="w-[1px] bg-white"></span>
          <Link to={"/privacyPolicy"}>Terms of use</Link>
        </div> */}
        <p className="flex items-center justify-center">
          Powered by{" "}
          <a className="underline ml-1" href="https://www.jewelmaker.it" target="_blank" rel="noopener noreferrer">
            JewelMaker
          </a>
        </p>
      </div>
    </div>
  );
};

export default FooterComponent;
